export const SEND_MESSAGE = "SEND_MESSAGE"
export const SET_USER = "SET_USER"
export const SET_SEARCH_BAR = "SET_SEARCH_BAR"
export const SET_MESSENGER_SEARCH = "SET_MESSENGER_SEARCH"
export const ADD_TO_BOOKMARK = "ADD_TO_BOOKMARK"